import {
  accessDeniedPageTag,
  journeyStartPageTag,
  privacyPolicyPageTag,
  sessionExpiredPageTag,
  serviceIntroductionPageTag,
  termsOfServicePageTag,
  type InavElementTag,
} from '@ui/elementTags';

export interface RouteDefinition {
  path: string;
  tagName?: string;
  title: string;
  load?: () => Promise<HTMLElement>;
}

async function loadRouteElement(tagName: InavElementTag, importer: () => Promise<unknown>): Promise<HTMLElement> {
  await importer();
  return document.createElement(tagName);
}

export const routes: RouteDefinition[] = [
  {
    load: () => loadRouteElement(serviceIntroductionPageTag, () => import('@ui/pages/ServiceIntroductionPage')),
    path: '/',
    tagName: serviceIntroductionPageTag,
    title: 'Check your symptoms | INAV'
  },
  {
    load: () => loadRouteElement(journeyStartPageTag, () => import('@ui/pages/HomePage')),
    path: '/journey-start',
    tagName: journeyStartPageTag,
    title: 'Journey start | INAV'
  },
  {
    load: () => loadRouteElement(accessDeniedPageTag, () => import('@ui/pages/AccessDeniedPage')),
    path: '/access-denied',
    tagName: accessDeniedPageTag,
    title: 'Access denied | INAV'
  },
  {
    load: () => loadRouteElement(sessionExpiredPageTag, () => import('@ui/pages/SessionExpiredPage')),
    path: '/session-expired',
    tagName: sessionExpiredPageTag,
    title: 'Session expired | INAV'
  },
  {
    load: () => loadRouteElement(privacyPolicyPageTag, () => import('@ui/pages/PrivacyPolicyPage')),
    path: '/legal/privacy-policy',
    tagName: privacyPolicyPageTag,
    title: 'Privacy Policy | INAV'
  },
  {
    load: () => loadRouteElement(termsOfServicePageTag, () => import('@ui/pages/TermsOfServicePage')),
    path: '/legal/terms-of-service',
    tagName: termsOfServicePageTag,
    title: 'Terms of Service | INAV'
  }
];